import "babel-polyfill"
require("javascripts/polyfills/array");
require("javascripts/polyfills/form");
// require("javascripts/redactorx-init");
require("javascripts/article-editor-init");
import {setTimezoneCookie} from "../javascripts/jstimezoneinit.js";

setTimezoneCookie()

String.prototype.capitalized = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

window.POC = window.POC || {};
window.POC.csrfToken = function () {
  const csrf = document.querySelector('meta[name="csrf-token"]')
  return csrf ? csrf.getAttribute('content') : null;
};

// YARN managed dependencies
import $ from 'jquery';

global.$ = jQuery;

require("@rails/ujs").start();
require("bootstrap");
require("bootstrap-select");
require("@nathanvda/cocoon");
require("dropzone");
require("daterangepicker");
require("../custom/js/app")
import "chartkick/chart.js"

import Dropzone from 'dropzone'
Dropzone.autoDiscover = false

require("country-region-selector");
require("trix");

require("javascripts/Theme");
require("javascripts/onboarding");
require("javascripts/countries");
require("javascripts/mega_menu");
require("javascripts/search");
require("javascripts/images");
require("javascripts/bootstrap_select");
require("javascripts/tooltips");
require("javascripts/popover");
require("javascripts/sidebar");
require("javascripts/users");
require("javascripts/CustomerCarousel");
require("javascripts/vue/initializers");
require("javascripts/trix-attachments")
require("javascripts/rights-managed-pricing");
require("javascripts/admin_subscriptions");
require("javascripts/ContributorSearch");
require("javascripts/CustomerSearch");
require("javascripts/FtpFolderSearch");
require("sharer.js");
require("javascripts/sharer-init.js");
require("javascripts/SelectCheckboxes.js");
require("javascripts/range_picker_init");
require("javascripts/autosubmit_init");

// TODO: some components auto import css, like select2, in the require statements above.
//  Placing the css import at the bottom of the pack will allow our overrides to work
import '../stylesheets/application.scss'